import React from 'react'
import "../css/Shimmer.css"
const Shimmer = ({type = "" , className  , colSpan , style }) => {
  return <>
   {type === "" && <>
  <div className={`${className}`}>
  <div className="loading-placeholder shimmer" style={style} ></div>
</div>
 </>}
 {type === "text" && <>
  <div className={`${className}`}>
  <div className="loading-placeholder shimmer" style={style} ></div>
</div>
 </>}
 {type === "table" && <>
  <tr className={`${className}`}>
  <td colSpan={colSpan} className="loading-placeholder shimmer" style={style} ></td>
</tr>
 </>}
  </>
}

export default Shimmer